import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type AssetForOpenInCreativeCloudApp_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_FileAsset_Fragment = { __typename?: 'FileAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string, name: string, acpId?: string | null, media?: { __typename?: 'ImageMedia', id: string, mimeType?: string | null } | null };

export type AssetForOpenInCreativeCloudApp_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudApp_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string, name: string, acpId?: string | null, versions?: Array<{ __typename?: 'AudioAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'DocumentAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'FileAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'FolderAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'ImageAsset', id: string, name: string, acpId?: string | null, media?: { __typename?: 'ImageMedia', id: string, mimeType?: string | null } | null } | { __typename?: 'InteractiveAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'InteractiveLiveAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'ModelAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'UnsupportedAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'VersionStackAsset', id: string, name: string, acpId?: string | null } | { __typename?: 'VideoAsset', id: string, name: string, acpId?: string | null }> | null };

export type AssetForOpenInCreativeCloudApp_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, name: string, acpId?: string | null };

export type AssetForOpenInCreativeCloudAppFragment = AssetForOpenInCreativeCloudApp_AudioAsset_Fragment | AssetForOpenInCreativeCloudApp_DocumentAsset_Fragment | AssetForOpenInCreativeCloudApp_FileAsset_Fragment | AssetForOpenInCreativeCloudApp_FolderAsset_Fragment | AssetForOpenInCreativeCloudApp_ImageAsset_Fragment | AssetForOpenInCreativeCloudApp_InteractiveAsset_Fragment | AssetForOpenInCreativeCloudApp_InteractiveLiveAsset_Fragment | AssetForOpenInCreativeCloudApp_ModelAsset_Fragment | AssetForOpenInCreativeCloudApp_UnsupportedAsset_Fragment | AssetForOpenInCreativeCloudApp_VersionStackAsset_Fragment | AssetForOpenInCreativeCloudApp_VideoAsset_Fragment;

export const AssetForOpenInCreativeCloudApp = /*#__PURE__*/ gql`
    fragment AssetForOpenInCreativeCloudApp on Asset {
  id
  name
  acpId
  ... on ImageAsset {
    media {
      id
      mimeType
    }
  }
  ... on VersionStackAsset {
    versions {
      id
      name
      acpId
      ... on ImageAsset {
        media {
          id
          mimeType
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<AssetForOpenInCreativeCloudAppFragment, unknown>;

        

        
export const useAssetForOpenInCreativeCloudAppFragment = (
  input: string | Omit<UseFragmentOptions<AssetForOpenInCreativeCloudAppFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<AssetForOpenInCreativeCloudAppFragment>({
    fragment: AssetForOpenInCreativeCloudApp,
    fragmentName: 'AssetForOpenInCreativeCloudApp',
    ...options,
  });
};
  
        